import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap";
import { NgForm } from "@angular/forms";
import * as ps from "perfect-scrollbar";
import { BlurUtil } from "../../../../common/utils/blurUtil";
import { Seller } from "../../../../objects/amazon/seller";
import { AmazonStoreCredentials } from "../../../../objects/amazon/AmazonStoreCredentials";
import { Router } from "@angular/router";

@Component({
    selector: 'seller-modal',
    templateUrl: 'seller-modal.component.html',
    moduleId: module.id.toString()
})
export class SellerModalComponent {

    @Input()
    public idToBlur: string;

    @ViewChild('sellerModal')
    public sellerModal: ModalDirective;

    @ViewChild("sellerForm")
    public sellerForm: NgForm;
    @ViewChild('sellerModalRef')
    public sellerModalRef: ElementRef;

    public originalSeller: Seller = new Seller();
    public currentSeller: Seller = new Seller();

    public string = String;
    public number = Number;

    constructor(private router: Router,) {
    }

    public async show(seller: Seller): Promise<void> {
        this.originalSeller = seller;
        this.currentSeller = JSON.parse(JSON.stringify(seller));
        this.sellerModal.show();

        BlurUtil.blurMenu(this.idToBlur);
    }

    public ngOnInit(): void {
        ps.initialize(this.sellerModalRef.nativeElement);
    }

    public onModalHidden(): void {
        this.sellerForm.reset();
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public showStore(store: AmazonStoreCredentials): void {
        BlurUtil.unBlurMenu(this.idToBlur);
        this.router.navigate([`management/amazon/seller/${this.currentSeller.Id}/store/${store.Id}`]);
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/seller/seller-modal.component.ts